// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_model {
  display: grid;
  grid-template-areas:
    "heading          heading          heading          heading          ."
    "brand            series           ratio            buttonreset      ."
    "dropdowncassette dropdowncassette dropdowncrankset dropdowncrankset ."
    "teethscassette   teethscass1ette  teethscrankset   teethscrankset   ."
    ".                .                .                buttonaddtograph ."
    "table            table            table            table            .";
  grid-template-rows: auto auto auto auto auto 1fr;
  /* justify-items: center; */
  align-items: center;
}

.model-filter.dropdown.brand {
  grid-area: brand;
}

.model-filter.dropdown.series {
  grid-area: series;
}

.model-filter.dropdown.ratio {
  grid-area: ratio;
}

.model-filter-reset {
  grid-area: buttonreset;
}

.all-cassettes {
  grid-area: dropdowncassette;
}

.all-cranksets {
  grid-area: dropdowncrankset;
}

.model-filter-addtograph {
  grid-area: buttonaddtograph;
}

.model-filter-addtograph,
.model-filter-reset {
  border: 1px solid var(--color-darker);
  border-radius: 1rem;
  padding-left: 3%;
  padding-right: 3%;
  color: var(--color-darkest);
  background: var(--color-middle);
  transition: background-color 0.3s;
}

.model-filter-addtograph:hover,
.model-filter-reset:hover {
  border: 1px solid var(--color-light);
  background: var(--color-darker);
  color: var(--color-light);
  cursor: pointer;
}

.model-filter-reset {
  width: 80%;
  height: 80%;
  justify-self: center;
  background-color: hsla(5, 28%, 65%, 1);
}

.dropdown {
  display: flex;
  flex-direction: column;
  padding: 3%;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/tabModel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;;;;;2EAMyE;EACzE,gDAAgD;EAChD,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".container_model {\n  display: grid;\n  grid-template-areas:\n    \"heading          heading          heading          heading          .\"\n    \"brand            series           ratio            buttonreset      .\"\n    \"dropdowncassette dropdowncassette dropdowncrankset dropdowncrankset .\"\n    \"teethscassette   teethscass1ette  teethscrankset   teethscrankset   .\"\n    \".                .                .                buttonaddtograph .\"\n    \"table            table            table            table            .\";\n  grid-template-rows: auto auto auto auto auto 1fr;\n  /* justify-items: center; */\n  align-items: center;\n}\n\n.model-filter.dropdown.brand {\n  grid-area: brand;\n}\n\n.model-filter.dropdown.series {\n  grid-area: series;\n}\n\n.model-filter.dropdown.ratio {\n  grid-area: ratio;\n}\n\n.model-filter-reset {\n  grid-area: buttonreset;\n}\n\n.all-cassettes {\n  grid-area: dropdowncassette;\n}\n\n.all-cranksets {\n  grid-area: dropdowncrankset;\n}\n\n.model-filter-addtograph {\n  grid-area: buttonaddtograph;\n}\n\n.model-filter-addtograph,\n.model-filter-reset {\n  border: 1px solid var(--color-darker);\n  border-radius: 1rem;\n  padding-left: 3%;\n  padding-right: 3%;\n  color: var(--color-darkest);\n  background: var(--color-middle);\n  transition: background-color 0.3s;\n}\n\n.model-filter-addtograph:hover,\n.model-filter-reset:hover {\n  border: 1px solid var(--color-light);\n  background: var(--color-darker);\n  color: var(--color-light);\n  cursor: pointer;\n}\n\n.model-filter-reset {\n  width: 80%;\n  height: 80%;\n  justify-self: center;\n  background-color: hsla(5, 28%, 65%, 1);\n}\n\n.dropdown {\n  display: flex;\n  flex-direction: column;\n  padding: 3%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
